/*================================================================
‘Copyright © 2024, Cheers Interactive Pvt Ltd.  All rights reserved.
   File Description :  Personalization Page
 --------------------------------------------------------------------------------- 
  Creation Details 
  Date Created			: 17/05/2024 
  Author						: Suraj Yadav
================================================================ 
*/
import React, { useEffect } from "react";
import { showLoader, hideLoader, actionError } from "../../../middleware/actions/utilityAction";
import { PLATFORM_PERSONALIZATION_URL } from "../../../constants";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

export default () => {
  // ** HOOKS **
  const history = useHistory();
  const dispatch = useDispatch();

  // ** UTILS **
  const checkEligiblity = async () => {
    const enterpriseToken = localStorage.getItem("enterprise");
    const userId = localStorage.getItem("enterpriseUserId");
    const refreshToken = localStorage.getItem("refresh-token");
    const clientName = import.meta.env.VITE_ENTERPRISE_CLIENT_NAME;
    if (!userId || !enterpriseToken) return history.push("/login");
    if (enterpriseToken === "undefined" || !enterpriseToken || typeof enterpriseToken !== "string")
      return dispatch(actionError("Unable to access platform personalization."));
    dispatch(showLoader());
    redirectToPlatformPersonalization(userId, clientName, enterpriseToken, refreshToken);
    setTimeout(() => dispatch(hideLoader()), 5000);
  };

  const redirectToPlatformPersonalization = (e, c, t, r) =>
    window.open(PLATFORM_PERSONALIZATION_URL + "/auto-login?loginUserId=" + e + "&clientName=" + c + "&token=" + t + "&refreshToken=" + r);

  // ** EFFECTS **
  useEffect(() => {
    checkEligiblity();
  }, []);

  return (
    <div
      className="gennx-content-wrapper content-wrapper px-3"
      style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%", flexDirection: "column" }}
    >
      <h4>Personalization is now a standalone app.</h4>
      <h6>Please wait while we redirect and log you in.</h6>

      <button onClick={checkEligiblity}>Click here if you are not redirected.</button>
    </div>
  );
};
